module.exports = __webpack_public_path__ + "hM0gekQOUVruWAbHF/illo-couple-phone.svg";